import apiClient from './apiClient';

export const mahnungApi = {
  /**
   * Mahnungen einer Rechnung abrufen
   */
  getMahnungenByRechnung: async (rechnungId) => {
    const response = await apiClient.get(`/mahnungen/rechnung/${rechnungId}`);
    return response.data;
  },

  /**
   * Manuelle Mahnung erstellen und versenden
   */
  erstelleManuelleMahnung: async (rechnungId, mahnstufe) => {
    const response = await apiClient.post('/mahnungen/manuell', {
      rechnungId,
      mahnstufe
    });
    return response.data;
  },

  /**
   * Mahnlauf manuell auslösen
   */
  triggereMahnlauf: async () => {
    const response = await apiClient.post('/mahnungen/mahnlauf');
    return response.data;
  },

  /**
   * Mahnwesen-Statistiken abrufen
   */
  getStatistiken: async () => {
    const response = await apiClient.get('/mahnungen/statistiken');
    return response.data;
  },

  /**
   * Cron-Status abrufen
   */
  getCronStatus: async () => {
    const response = await apiClient.get('/mahnungen/status');
    return response.data;
  },

  /**
   * Einstellungen abrufen
   */
  getEinstellungen: async () => {
    const response = await apiClient.get('/mahnungen/einstellungen');
    return response.data;
  },

  /**
   * Einstellungen speichern
   */
  updateEinstellungen: async (einstellungen) => {
    const response = await apiClient.post('/mahnungen/einstellungen', einstellungen);
    return response.data;
  }
};

export default mahnungApi;
